import React from 'react';
import classnames from 'classnames';
import {formattingDate} from "../../../utils/formatting";
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import styles from './styles.module.scss';

const Section8Text15 = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {identifyMethodType, joinHomeRegistryDate} = context.data.pdfData;

  return (
    <div ref={ref}>
      {Boolean(joinHomeRegistryDate) && identifyMethodType === 2 && (
        <div className={classnames(styles.itemText, styles.innerPadding)}>
          <span className={classnames(styles.bold, styles.itemNumber)}>-   </span>
          <span className={styles.bold}>תאריך: </span>
          <span>{formattingDate(joinHomeRegistryDate)}</span>
        </div>
      )}
    </div>
  );
});

export default Section8Text15;
